import api from 'api';

export const loadMessages = api('GET /api/ai-chatbot/:chatId/messages');
export const createMessage = api('POST /api/ai-chatbot/message');
export const getJobStatus = api('GET /api/ai-chatbot/message/jobs/:jobId');
export const markMessage = api('PUT /api/ai-chatbot/message/:messageId/mark');
